import { logger } from '../../utils/logger';

export function parseSapCtiXml(
  xmlString: string
): { phoneNumber: string; contactId?: string } | null {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xmlString, 'text/xml');

    const parseError = doc.querySelector('parsererror');
    if (parseError) {
      return null;
    }

    const payload = doc.querySelector('payload');
    if (!payload) {
      return null;
    }

    const eventType = payload.querySelector('EventType')?.textContent?.toUpperCase();
    const action = payload.querySelector('Action')?.textContent?.toUpperCase();
    const ani = payload.querySelector('ANI')?.textContent;
    const contactId = payload.querySelector('ContactID')?.textContent;

    if (eventType === 'OUTBOUND' && ani) {
      logger.debug('[SAP Context] Parsed OUTBOUND XML, ANI:', ani, 'ContactID:', contactId);
      return { phoneNumber: ani, contactId: contactId || undefined };
    }

    if (action === 'DIAL' && ani) {
      logger.debug('[SAP Context] Parsed DIAL XML, ANI:', ani, 'ContactID:', contactId);
      return { phoneNumber: ani, contactId: contactId || undefined };
    }

    return null;
  } catch (error) {
    console.debug('[SAP Context] XML parse failed (expected for non-XML):', error);
    return null;
  }
}
